import { NewquanlytonkhoService } from 'src/services/newquanlytonkho.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const NEWQUANLYTONKHO_NEW_CARE_SUCCESS = 'NEWQUANLYTONKHO:NEW_CARE_SUCCESS'
export const NEWQUANLYTONKHO_LIST_SUCCESS = 'NEWQUANLYTONKHO:FIND_ALL_SUCCESS'
export const NEWQUANLYTONKHO_LIST_FAILD = 'NEWQUANLYTONKHO:FIND_ALL_FAILD'
export const NEWQUANLYTONKHO_COUNT_ASSIGN_SUCCESS = 'NEWQUANLYTONKHO:COUNT_ASSIGN_SUCCESS'
export const NEWQUANLYTONKHO_COUNT_ASSIGN_FAILD = 'NEWQUANLYTONKHO:COUNT_ASSIGN_FAILD'

export const NEWQUANLYTONKHO_CREATE_SUCCESS = 'NEWQUANLYTONKHO:CREATE_SUCCESS'
export const NEWQUANLYTONKHO_CREATE_FAILD = 'NEWQUANLYTONKHO:CREATE_FAILD'

export const NEWQUANLYTONKHO_IMPORT_SUCCESS = 'NEWQUANLYTONKHO:IMPORT_SUCCESS'
export const NEWQUANLYTONKHO_SAVE_SUCCESS = 'NEWQUANLYTONKHO:SAVE_SUCCESS'
export const NEWQUANLYTONKHO_SAVE_FAILD = 'NEWQUANLYTONKHO:SAVE_SUCCESS'

export const NEWQUANLYTONKHO_DEL_SUCCESS = 'NEWQUANLYTONKHO:DEL_SUCCESS'
export const NEWQUANLYTONKHO_DEL_FAILD = 'NEWQUANLYTONKHO:DEL_FAILD'

export const NEWQUANLYTONKHO_ONE_SUCCESS = 'NEWQUANLYTONKHO:FIND_ONE_SUCCESS'
export const NEWQUANLYTONKHO_ONE_FAILD = 'NEWQUANLYTONKHO:FIND_ONE_FAILD'

export const NEWQUANLYTONKHO_LAYDANHSACHTON_SUCCESS = 'NEWQUANLYTONKHO:FIND_LAYDANHSACHTON_SUCCESS'
export const NEWQUANLYTONKHO_LAYDANHSACHTON_FAILD = 'NEWQUANLYTONKHO:FIND_LAYDANHSACHTON_FAILD'

export const NEWQUANLYTONKHO_HISTORY_LIST_SUCCESS = 'NEWQUANLYTONKHO:HISTORY_FIND_ALL_SUCCESS'
export const NEWQUANLYTONKHO_HISTORY_LIST_FAILD = 'NEWQUANLYTONKHO:HISTORY_FIND_ALL_FAILD'

export const NEWQUANLYTONKHO_UPDATE_FILTER = 'NEWQUANLYTONKHO:NEWQUANLYTONKHO_UPDATE_FILTER'

export const NEWQUANLYTONKHO_LIST_EXPORT_SUCCESS = 'NEWQUANLYTONKHO:FIND_ALL_EXPORT_SUCCESS'
export const NEWQUANLYTONKHO_LIST_EXPORT_FAILD = 'NEWQUANLYTONKHO:FIND_ALL_EXPORT_FAILD'

export const NEWQUANLYTONKHO_UPDATE_HOMEPAGE_FILTER = 'NEWQUANLYTONKHO:NEWQUANLYTONKHO_UPDATE_HOMEPAGE_FILTER'

export const NEWQUANLYTONKHO_HOMEPAGE_LIST_SUCCESS = 'NEWQUANLYTONKHO:FIND_HOMEPAGE_LIST_SUCCESS'
export const NEWQUANLYTONKHO_HOMEPAGE_LIST_FAILD = 'NEWQUANLYTONKHO:FIND_HOMEPAGE_LIST_FAILD'

export const NEWQUANLYTONKHO_HOMEPAGE_ONE_SUCCESS = 'NEWQUANLYTONKHO:FIND_HOMEPAGE_ONE_SUCCESS'
export const NEWQUANLYTONKHO_HOMEPAGE_ONE_FAILD = 'NEWQUANLYTONKHO:FIND_HOMEPAGE_ONE_FAILD'

export const NEWQUANLYTONKHO_ORDER_SUCCESS = 'NEWQUANLYTONKHO:ORDER_SUCCESS'
export const NEWQUANLYTONKHO_ORDER_FAILD = 'NEWQUANLYTONKHO:ORDER_FAILD'

export const NEWQUANLYTONKHO_GET_SIM_ANALYSIS_SUCCESS = 'NEWQUANLYTONKHO:GET_SIM_ANALYSIS_SUCCESS'
export const NEWQUANLYTONKHO_GET_SIM_ANALYSIS_FAILD = 'NEWQUANLYTONKHO:GET_SIM_ANALYSIS_FAILD'

export const NEWQUANLYTONKHO_HANDLE_IMPORT_ERRORS = 'NEWQUANLYTONKHO:NEWQUANLYTONKHO_HANDLE_IMPORT_ERRORS'

export const NewquanlytonkhoAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    layDanhSachTon,
    updateFilter,
    saveDataUpload,
    findPackage,
    listExport,
    listNoLimit,
    homepageList,
    updateHomepageFilter,
    homepageFindOne,
    sendOrder,
    getSimAnalysis,
    sanphamList,
    dieuChuyen,
    dieuChuyenLichSu,
}

function dieuChuyen(payload) {
    return dispatch => {
        NewquanlytonkhoService.dieuChuyen(payload).then((rs) => {
            alert("Đã điều chuyển. Vui lòng refresh lại danh sách!")
        }).catch((error) => {
            alert("Không thể điều chuyển. Vui lòng kiểm tra lại!");
        }).finally(() => {
            //
        })
    };
}

function dieuChuyenLichSu(payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewquanlytonkhoService.dieuChuyenLichSu(payload)
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function sanphamList() {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewquanlytonkhoService.sanphamList()
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function getSimAnalysis(number) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            // dispatch(AppAction.appLoading(true));
            NewquanlytonkhoService.getSimAnalysis(number).then((response) => {
                dispatch(success(response.data));
                resolve(response);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: NEWQUANLYTONKHO_GET_SIM_ANALYSIS_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_GET_SIM_ANALYSIS_FAILD, error } }
}

function updateHomepageFilter(payload) {
    return { type: NEWQUANLYTONKHO_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { newquanlytonkho } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageNewquanlytonkhoFilter } = newquanlytonkho;
        const homepageNewquanlytonkhoPage = homepageNewquanlytonkhoFilter.homepageNewquanlytonkhoPage;
        const homepageNewquanlytonkhoLimit = homepageNewquanlytonkhoFilter.homepageNewquanlytonkhoLimit;

        return new Promise((resolve, reject) => {
            NewquanlytonkhoService.homepageList(homepageNewquanlytonkhoFilter).then((rs) => {
                if (!!homepageNewquanlytonkhoFilter && homepageNewquanlytonkhoFilter.homepageNewquanlytonkhoPage === 0) {
                    dispatch(success({
                        homepageNewquanlytonkhoItems: rs.data.values,
                        homepageNewquanlytonkhoTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = newquanlytonkho.homepageNewquanlytonkhoItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageNewquanlytonkhoLimit * homepageNewquanlytonkhoPage; i < homepageNewquanlytonkhoLimit * homepageNewquanlytonkhoPage + homepageNewquanlytonkhoLimit; i++) {
                        if (typeof rsDataValues[i - homepageNewquanlytonkhoLimit * homepageNewquanlytonkhoPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageNewquanlytonkhoLimit * homepageNewquanlytonkhoPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageNewquanlytonkhoItems: uniqueItems,
                        homepageNewquanlytonkhoTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWQUANLYTONKHO_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewquanlytonkhoService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWQUANLYTONKHO_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: NEWQUANLYTONKHO_UPDATE_FILTER, data: payload }
}

function listNoLimit() {
    return (dispatch, getState) => {
      const { account } = getState()
      dispatch(AppAction.appLoading(true));
      NewquanlytonkhoService.listNoLimit().then((rs) => {
        dispatch(success({
            items: rs.data.values,
            total: rs.data.count
        }));
      }).catch((error) => {
        dispatch(failure(error));
      }).finally(() => {
        dispatch(AppAction.appLoading(false));
      })
    };
    function success(data) { return { type: NEWQUANLYTONKHO_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_LIST_FAILD, error } }
  }

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewquanlytonkhoService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWQUANLYTONKHO_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { newquanlytonkho } = getState()
        dispatch(AppAction.appLoading(true));
        NewquanlytonkhoService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newquanlytonkho.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWQUANLYTONKHO_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_LIST_FAILD, error } }
}

function saveDataUpload(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0;
        let errorRows = {};
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewquanlytonkhoService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                // if (count === payload.length) {
                //     dispatch(success(rs));
                //     dispatch(AppAction.appLoading(false));
                // }

                if (rs.data.errorRows) {
                    Object.entries(rs.data.errorRows).forEach(([key, value]) => {
                        errorRows[i * 200 + Number(key)] = value;
                    });
                }

                if (i + 200 >= payload.length) {
                    dispatch(handleErrors(errorRows));
                    dispatch(success(rs));
                    dispatch(NewquanlytonkhoAction.list());
                    alert("Tải file thành công: \"" + payload[0].ten_file_upload + "\" (" + count + " bản ghi)");
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function handleErrors(data) { return { type: NEWQUANLYTONKHO_HANDLE_IMPORT_ERRORS, data } }
    function success(data) { return { type: NEWQUANLYTONKHO_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_SAVE_FAILD, error } }
}

function findPackage(ten_goi_cuoc) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewquanlytonkhoService.findPackage(ten_goi_cuoc)
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { newquanlytonkho } = getState();

            const { filter } = newquanlytonkho;

            // Perform your asynchronous operation (e.g., API call)
            NewquanlytonkhoService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: NEWQUANLYTONKHO_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_LIST_EXPORT_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { newquanlytonkho } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = newquanlytonkho;
        const page = filter.page;
        const limit = filter.limit;

        return new Promise((resolve, reject) => {
            NewquanlytonkhoService.findAll(filter.page, filter.limit, filter).then((rs) => {
                if (!!filter && filter.page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                    }));
                } else {
                    const oldItems = newquanlytonkho.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWQUANLYTONKHO_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: NEWQUANLYTONKHO_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewquanlytonkhoService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(NewquanlytonkhoAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: NEWQUANLYTONKHO_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_SAVE_FAILD, error } }
}

function create(payload, creatingFromAway = false) {
    return dispatch => {
        if (!creatingFromAway) dispatch(AppAction.appLoading(true));
        NewquanlytonkhoService.create(payload).then((rs) => {
            dispatch(success(rs));
            if (!creatingFromAway) dispatch(NewquanlytonkhoAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể tạo, có thể do trùng mã!");
        }).finally(() => {
            if (!creatingFromAway) dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWQUANLYTONKHO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_CREATE_FAILD, error } }
}

function update(id, payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewquanlytonkhoService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(NewquanlytonkhoAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể cập nhật, có thể do trùng mã!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWQUANLYTONKHO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewquanlytonkhoService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(NewquanlytonkhoAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWQUANLYTONKHO_DEL_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_DEL_FAILD, error } }
}

// function findOne(id) {
//     return (dispatch) => {
//         dispatch(AppAction.appLoading(true));
//         NewquanlytonkhoService.find(id).then((rs) => {
//             dispatch(success(rs.data));
//         }).catch((error) => {
//             dispatch(failure(error));
//         }).finally(() => {
//             dispatch(AppAction.appLoading(false));
//         })
//     };
//     function success(data) { return { type: NEWQUANLYTONKHO_ONE_SUCCESS, data } }
//     function failure(error) { return { type: NEWQUANLYTONKHO_ONE_FAILD, error } }
// }

function findOne(id, payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewquanlytonkhoService.find(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response.data));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: NEWQUANLYTONKHO_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_ONE_FAILD, error } }
}

function layDanhSachTon(id, payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewquanlytonkhoService.layDanhSachTon(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response.data));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: NEWQUANLYTONKHO_LAYDANHSACHTON_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_LAYDANHSACHTON_FAILD, error } }
}

function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewquanlytonkhoService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(NewquanlytonkhoAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}

function history(payload) {
    return (dispatch, getState) => {
        const { newquanlytonkho } = getState()
        dispatch(AppAction.appLoading(true));
        NewquanlytonkhoService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newquanlytonkho.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWQUANLYTONKHO_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_HISTORY_LIST_FAILD, error } }
}

function sendOrder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewquanlytonkhoService.sendOrder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt sim này, có thể do hiện tại sim này đã bán. Bạn vui lòng chọn sim khác. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWQUANLYTONKHO_ORDER_SUCCESS, data } }
    function failure(error) { return { type: NEWQUANLYTONKHO_ORDER_FAILD, error } }
}